import { gql } from '@apollo/client'

export const GET_BUSINESS_SITE = gql`
  query GetBusinessSite($id: UUID!) {
    businessSite(id: $id) {
      id
      name
      isActive
      kreditsSettings {
        amount
        name
        frequency {
          unit
          value
        }
      }
      client {
        id
        name
      }
      city {
        id
        name
      }
      contacts {
        id
        name
        phone
        secondaryPhone
        email
        secondaryEmail
      }
    }
  }
`

export const GET_BUSINESS_SITES = gql`
  query GetBusinessSites($input: BusinessSitesInput, $pagination: PaginationV2) {
    businessSites(input: $input, pagination: $pagination) {
      total
      items {
        id
        name
        isActive
        client {
          id
          name
        }
        city {
          id
          name
        }
      }
    }
  }
`

export const GET_BUSINESS_SITES_SUGGESTIONS = gql`
  query GetBusinessSitesSuggestions($input: BusinessSiteSuggestionsInput!) {
    businessSiteSuggestions(input: $input) {
      items {
        id
        name
        businessClient {
          id
          name
        }
      }
    }
  }
`
